var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block cms-runner-list"},[_c('RunnerSearch',{attrs:{"runners":_vm.runners,"search-group":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }